/**
 * Return an ISO‑2 country code (GB, FR, DE, …) from the browser locale.
 * Falls back to GB if nothing obvious is available.
 */
export const getCountryFromLocale = (): string => {
  // preferred list first, then primary language
  const loc = (navigator.languages?.[0] || navigator.language || "en-GB")
                .replace("_", "-");          // fr_FR → fr-FR
  // Modern browsers: Intl.Locale gives a .region
  if ((Intl as any).Locale) {
    try {
      const region = new (Intl as any).Locale(loc).region;
      //console.log('Region: ', region);
      if (region) return region.toUpperCase();
    } catch {/* ignore */}
  }
  // Old fallback → 'en-GB' → ['en','GB']
  const parts = loc.split("-");
  return (parts[1] || "GB").toUpperCase();
};